module.exports = "<div class=\"support\">\n\n    <h3>Support</h3>\n    <div class=\"support-closed\"></div>\n    <div class=\"support-body\">\n        <input type=\"text\" [(ngModel)]=\"linkPhoto\" placeholder=\"Link a photo\" />\n        <textarea placeholder=\"Describe the problem\" [(ngModel)]=\"message\">\n        </textarea>\n        <button>Send</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/support/index.html
// module id = ./src/app/components/support/index.html
// module chunks = main